module.exports = __webpack_public_path__ + "static/media/notifications-small.494702d3.png";